// @flow
import React, { createContext, useContext, useState } from 'react';

// Create context with default values
const AppContext = createContext({
	isAdmin: false,
});

// Provider component
type AppProviderProps = {
	children: React.Node,
	isAdmin?: boolean,
};

export const AppProvider = ({ children, isAdmin = false }: AppProviderProps) => {
	const value = {
		isAdmin,
	};

	return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

// Hook for functional components
export const useAppContext = (): AppContextType => {
	const context = useContext(AppContext);
	if (!context) {
		throw new Error('useAppContext must be used within an AppProvider');
	}
	return context;
};

// HOC for class components
export const withAppContext = (Component: React.ComponentType<any>) => {
	// Flow type for the wrapped component props
	type WithAppContextProps = {
		appContext?: AppContextType,
	};

	const displayName = Component.displayName || Component.name || 'Component';

	const WithAppContext = (props: WithAppContextProps) => {
		const context = useAppContext();
		return <Component {...props} appContext={context} />;
	};

	WithAppContext.displayName = `withAppContext(${displayName})`;
	return WithAppContext;
};

// Export the context for direct usage if needed
export default AppContext;



// WEBPACK FOOTER //
// src/AppContext.jsx